export class BeachyError extends Error {
  originalStackTrace?: Error;
  needToLog: boolean;

  constructor(args: { message: string; originalStackTrace?: Error; needToLog?: boolean }) {
    const { message, originalStackTrace, needToLog } = args;
    super(message);

    this.originalStackTrace = originalStackTrace;
    this.needToLog = !!needToLog;
  }
}
